import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import {
    getFormattedPhoneNumber,
    accountNumberZeroTrimmer,
} from 'src/utils/util';
import {
    EmailContainer,
    PhoneContainer,
    SpecialityGrid,
    OrderDetailTabBodyContainer,
    FavouriteIcon,
    HeaderContainer,
    HeaderTextContainer,
    BodyGridContainer,
    BodyTextContainer,
    CityGrid,
    EmailPhoneGrid,
    FavouriteIconDesktopContainer,
    HeaderTextContainer1,
    ContactInfo,
    DesktopView,
    FavouriteIconMobile,
    FavoriteIconMobileContainer,
    PaginationContainerMobile,
    DesktopViewPagination,
    PaginationContainer,
    MobileView,
    AccountPaginationWrapper,
    StyledPhoneFax,
} from './AssociatedPhysicians.styled';
import FavoriteActive from 'src/assets/images/FavoriteActive.svg';
import FavoriteInActive from 'src/assets/images/favorite-inactive.svg';
import { AccountDetailsContainer } from 'src/pages/more/pages/accounts/components/accountList/index.styled';
import Grid from '@material-ui/core/Grid';
import PhysicianDetails from '../../../physicians/components/physicianDetails';
import {
    getPhysicianDetailss,
    setShowUnsavedPhysician,
    closePhysicianPopUP,
    setSelectedPhysician,
    setPhysicianDetailTabAction,
} from 'src/pages/more/redux/actions';
import BasicPagination from 'src/common/refactoredComponents/paginator';
import { useTranslation } from 'react-i18next';
import {
    CC_USER_ROLE,
    CSR_USER_ROLE,
    FIA_USER_ROLE,
    FIM_USER_ROLE,
    ITA_USER_ROLE,
} from 'src/constants/appConstants';
import { useEffectWithErrorLogging} from 'src/utils/useEffectWithErrorLogging';

const AssociatedPhysicians = ({
    associatedPhysicians,
    handleFavourite,
    employeeRole,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [showPopup, setShowPopup] = useState(false);
    const [physicianDetail, setPhysicianDetail] = useState([]);
    const [associatedData, setAssociatedData] = useState(
        associatedPhysicians && associatedPhysicians.slice(0, 50)
    );
    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);

    const PagescrollingRef = useRef();
    const physicianDetailsRef = useRef();
    const onPageChange = (event) => {
        setFirst(event.first);
        setPage(event.page);
    };
    const { physicianDropdownZGMorePhysicianVisibility } = useSelector(
        (state) => state.loginReducer
    );

    const salesOrg = useSelector((state) => state.loginReducer.salesOrg);
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const commonUnsavedchanges = useSelector(
        (state) => state.accountReducer.commonUnsavedchangesPhysician
    );

    const handleClick = (physician) => {
        dispatch(
            setPhysicianDetailTabAction({ selectedTabId: 'physicianDetails' })
        );

        dispatch(getPhysicianDetailss({ accountId: physician.physicianId }));
        dispatch(setSelectedPhysician(physician));
        setPhysicianDetail(physician);
        setShowPopup(true);
        physician;
    };
    useEffectWithErrorLogging(() => {
        PagescrollingRef.current?.scrollTo(0, 0);
    }, [first, page]);
    useEffectWithErrorLogging(() => {
        if (showPopup) {
            const oldPhysicanId =
                physicianDetail && physicianDetail?.physicianId
                    ? physicianDetail.physicianId
                    : null;
            if (oldPhysicanId) {
                const physicianIndex = associatedPhysicians.findIndex(
                    (x) => x.physicianId === oldPhysicanId
                );
                if (physicianIndex >= 0) {
                    const nwPhysicianDetails =
                        associatedPhysicians[physicianIndex];
                    setPhysicianDetail(nwPhysicianDetails);
                }
            }
        }
    }, [associatedPhysicians]);
    const handleClose = () => {
        if (commonUnsavedchanges) {
            dispatch(setShowUnsavedPhysician(true));
        } else {
            // dispatch(showAccountDetails(false));
            setShowPopup(false);

            dispatch(closePhysicianPopUP(true));
        }
    };
    useEffectWithErrorLogging(() => {
        const startIndex = (page + 1) * 50 - 50;
        const endIndex = startIndex + 50;
        const data =
            associatedPhysicians &&
            associatedPhysicians.slice(startIndex, endIndex);
        setAssociatedData(data);
    }, [page, associatedPhysicians]);

    return (
        <>
            {associatedData === undefined ? (
                <DesktopView>
                    <div style={{ margin: '10px 0' }}>
                        {t(
                            'accounts.associatedPhysicians.noAssociatedPhysicianRelatedToThisAccount'
                        )}
                    </div>
                </DesktopView>
            ) : (
                <>
                    <HeaderContainer
                        container
                        justifyContent={'space-between'}
                        direction="row"
                    >
                        <HeaderTextContainer
                            item
                            xs={12}
                            sm={3}
                            md={3}
                            lg={3}
                            xl={3}
                            mobile={12}
                            key="accountName"
                        >
                            {t('accounts.associatedPhysicians.physician')}
                        </HeaderTextContainer>
                        <HeaderTextContainer
                            item
                            xs={12}
                            sm={3}
                            md={3}
                            lg={3}
                            xl={3}
                            mobile={12}
                            key="accountNumber"
                        >
                            {t('accounts.associatedPhysicians.speciality')}
                        </HeaderTextContainer>
                        <HeaderTextContainer
                            item
                            xs={12}
                            sm={2}
                            md={2}
                            lg={2}
                            xl={2}
                            mobile={12}
                            key="city"
                        >
                            {t('accounts.associatedPhysicians.city')},{' '}
                            {t('accounts.associatedPhysicians.state')}
                        </HeaderTextContainer>
                        <HeaderTextContainer1
                            item
                            xs={12}
                            sm={3}
                            md={3}
                            lg={3}
                            xl={3}
                            mobile={12}
                            key="district"
                        >
                            {t('accounts.associatedPhysicians.contactInfo')}
                        </HeaderTextContainer1>
                        <Grid
                            item
                            xs={12}
                            sm={1}
                            md={1}
                            lg={1}
                            xl={1}
                            mobile={12}
                            key="favourite"
                        ></Grid>
                    </HeaderContainer>
                    <OrderDetailTabBodyContainer ref={PagescrollingRef}>
                        {associatedData &&
                            associatedData.map((physician, index) => {
                                return (
                                    <BodyGridContainer
                                        container
                                        justifyContent={'space-between'}
                                        direction="row"
                                        key={index}
                                        onClick={() => handleClick(physician)}
                                    >
                                        <BodyTextContainer
                                            item
                                            xs={12}
                                            sm={3}
                                            md={3}
                                            lg={3}
                                            xl={3}
                                            mobile={12}
                                            key="accountName"
                                        >
                                            <div>
                                                <a
                                                // onClick={() =>
                                                //     handleClick(physician)
                                                // }
                                                >
                                                    <span
                                                        className="more-account-associated-physician-name-dt-mask"
                                                        style={{
                                                            fontFamily:
                                                                'AvenirNextWorld Demi',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        {physician.name}
                                                    </span>
                                                </a>{' '}
                                                <br></br>
                                                <span
                                                    style={{
                                                        color: '#000000',
                                                        fontFamily:
                                                            'AvenirNextWorld Regular',
                                                    }}
                                                >
                                                    {' '}
                                                    {/* {t(
                                                        'accounts.associatedPhysicians.hcpId'
                                                    )} */}
                                                    {salesOrg === 'S024' ||
                                                    countryISOCode === 'JP'
                                                        ? t(
                                                              'accounts.associatedPhysicians.sapId'
                                                          )
                                                        : t(
                                                              'accounts.associatedPhysicians.hcpId'
                                                          )}{' '}
                                                    &nbsp;
                                                    {physicianDropdownZGMorePhysicianVisibility ===
                                                    'VISIBLE'
                                                        ? accountNumberZeroTrimmer(
                                                              physician.physicianId
                                                          )
                                                        : physician.hcpId}
                                                    {/* {physician.hcpId} */}
                                                </span>
                                            </div>
                                            {employeeRole !== CC_USER_ROLE &&
                                                employeeRole !==
                                                    FIA_USER_ROLE &&
                                                employeeRole !==
                                                    FIM_USER_ROLE &&
                                                employeeRole !==
                                                    ITA_USER_ROLE &&
                                                employeeRole !==
                                                    CSR_USER_ROLE && (
                                                    <FavoriteIconMobileContainer
                                                        // value={account.accountId}
                                                        // onClick={(e) => {
                                                        //     handleFavourite(e, account);
                                                        //     // setInstantFavorite(!isInstantFavorite);
                                                        //     // favoriteOrUnfavorite(false);
                                                        // }}

                                                        onClick={(e) => {
                                                            handleFavourite(
                                                                physician
                                                            );
                                                            e.stopPropagation();
                                                            // setInstantFavorite(!isInstantFavorite);
                                                            // favoriteOrUnfavorite(false);
                                                        }}
                                                    >
                                                        <FavouriteIconMobile
                                                            mobilePath={
                                                                // isInstantFavorite
                                                                physician.isFavorite ===
                                                                true
                                                                    ? FavoriteActive
                                                                    : FavoriteInActive
                                                            }
                                                        />
                                                    </FavoriteIconMobileContainer>
                                                )}
                                        </BodyTextContainer>
                                        {/* <FavoriteIconMobileContainer
                                        // value={account.accountId}
                                        // onClick={(e) => {
                                        //     handleFavourite(e, account);
                                        //     // setInstantFavorite(!isInstantFavorite);
                                        //     // favoriteOrUnfavorite(false);
                                        // }}
                                        >
                                            <FavouriteIcon
                                                style={{
                                                    padding: '0px',
                                                    //marginBottom: '50px',
                                                    border: '1px solid #ebebeb',
                                                    borderRadius: '6px',

                                                    opacity: '1px',
                                                    top: '1251px',
                                                    left: '327px',
                                                    width: '24px',
                                                    height: '24px',

                                                    background:
                                                        '#ffffff 0% 0% no-repeat padding-box',
                                                    boxShadow:
                                                        '0px 0px 2px #00000029',
                                                    border: '1px solid #ebebeb',
                                                    display: '-webkit-box',
                                                    display: '-webkit-flex',
                                                    display: '-ms-flexbox',
                                                    display: 'flex',
                                                }}
                                                mobilePath={
                                                    // isInstantFavorite
                                                    physician.isFavorite ===
                                                    true
                                                        ? FavoriteActive
                                                        : FavoriteInActive
                                                }
                                            />
                                        </FavoriteIconMobileContainer> */}

                                        <SpecialityGrid
                                            item
                                            xs={12}
                                            sm={3}
                                            md={3}
                                            lg={3}
                                            xl={3}
                                            mobile={12}
                                            key="accountNumber"
                                            // key="favourite"
                                        >
                                            {physician.speciality}
                                        </SpecialityGrid>
                                        <CityGrid
                                            item
                                            xs={12}
                                            sm={2}
                                            md={2}
                                            lg={2}
                                            xl={2}
                                            mobile={12}
                                        >
                                            {physician.city +
                                                ', ' +
                                                physician.state}
                                        </CityGrid>
                                        <EmailPhoneGrid
                                            item
                                            xs={12}
                                            sm={3}
                                            md={3}
                                            lg={3}
                                            xl={3}
                                            mobile={12}
                                        >
                                            <EmailContainer>
                                                {physician.email}
                                            </EmailContainer>
                                            <PhoneContainer
                                                textTransform={'none'}
                                            >
                                                {physician.phone && (
                                                    <StyledPhoneFax className="more-account-associated-physician-phone-dt-mask"
                                                        paddingTop={
                                                            physician.email
                                                                ? '5px'
                                                                : '0px'
                                                        }
                                                    >
                                                        <ContactInfo>
                                                            {t(
                                                                'accounts.associatedPhysicians.phone'
                                                            )}{' '}
                                                        </ContactInfo>{' '}
                                                        {getFormattedPhoneNumber(
                                                            physician.phone
                                                        )}
                                                    </StyledPhoneFax>
                                                )}{' '}
                                                {/* <br></br> */}
                                                {physician.fax && (
                                                    <StyledPhoneFax className="more-account-associated-physician-fax-dt-mask"
                                                        paddingTop={
                                                            physician.email ||
                                                            physician.phone
                                                                ? '5px'
                                                                : '0px'
                                                        }
                                                    >
                                                        <ContactInfo>
                                                            {t(
                                                                'accounts.associatedPhysicians.fax'
                                                            )}{' '}
                                                        </ContactInfo>{' '}
                                                        {getFormattedPhoneNumber(
                                                            physician.fax
                                                        )}
                                                    </StyledPhoneFax>
                                                )}
                                            </PhoneContainer>
                                        </EmailPhoneGrid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={1}
                                            md={1}
                                            lg={1}
                                            xl={1}
                                            mobile={12}
                                            key="favourite"
                                        >
                                            {employeeRole !== CC_USER_ROLE &&
                                                employeeRole !==
                                                    FIA_USER_ROLE &&
                                                employeeRole !==
                                                    FIM_USER_ROLE &&
                                                employeeRole !==
                                                    ITA_USER_ROLE &&
                                                employeeRole !==
                                                    CSR_USER_ROLE && (
                                                    <FavouriteIconDesktopContainer
                                                        //value={account.accountId}
                                                        onClick={(e) => {
                                                            handleFavourite(
                                                                physician
                                                            );
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        <FavouriteIcon
                                                            style={{
                                                                padding: '2px',
                                                                border: '1px solid #ebebeb',
                                                                borderRadius:
                                                                    '6px',
                                                                opacity: '1px',
                                                                top: '1251px',
                                                                left: '327px',
                                                                width: '30px',
                                                                height: '30px',
                                                                background:
                                                                    '#ffffff 0% 0% no-repeat padding-box',
                                                                boxShadow:
                                                                    '0px 0px 2px #00000029',
                                                                cursor: 'pointer',
                                                            }}
                                                            mobilePath={
                                                                // isInstantFavorite
                                                                physician.isFavorite ===
                                                                true
                                                                    ? FavoriteActive
                                                                    : FavoriteInActive
                                                            }
                                                        />
                                                    </FavouriteIconDesktopContainer>
                                                )}
                                        </Grid>
                                    </BodyGridContainer>
                                );
                            })}
                    </OrderDetailTabBodyContainer>

                    <AccountPaginationWrapper>
                        <DesktopViewPagination className="account-pagination-wrapper">
                            <PaginationContainer>
                                <BasicPagination
                                    totalRecords={
                                        associatedPhysicians &&
                                        associatedPhysicians.length
                                    }
                                    recordsFetched={50}
                                    pageNumber={page}
                                    handleChange={(e) => onPageChange(e)}
                                    first={first}
                                    // recordsPerPage={pageLimit}
                                    margin="12px 0px"
                                    content={t(
                                        'accounts.accountDetailCard.showingPhysicians'
                                    )}
                                    iPadPaginatorInfoWidth={'100%'}
                                    iPadPaginatorWidth={'100%'}
                                    // flexDirection={'column'}
                                    // textAlign={'center'}
                                />
                            </PaginationContainer>
                        </DesktopViewPagination>
                        <MobileView className="mobile-pagination-wrapper">
                            <PaginationContainerMobile padding={'0px'}>
                                <BasicPagination
                                    totalRecords={
                                        associatedPhysicians &&
                                        associatedPhysicians.length
                                    }
                                    recordsFetched={50}
                                    pageNumber={page}
                                    handleChange={(e) => onPageChange(e)}
                                    first={first}
                                    mobilePadding={'2% 2% 2% 2%'}
                                    content={t(
                                        'accounts.accountDetailCard.showingPhysicians'
                                    )}
                                />
                            </PaginationContainerMobile>
                        </MobileView>
                    </AccountPaginationWrapper>
                    {showPopup && (
                        <ModalDialog
                            modalHeight={'calc(100vh - 130px)'}
                            modalWidth={'70%'}
                            smalModalWidth={'85%'}
                            left={'7%'}
                            right={'7%'}
                            bottom={'10%'}
                            padding={'0px'}
                            handleClose={()=> physicianDetailsRef.current.handleClose()}
                            isIPadPotrait={false}
                            zIndex={'2000'}
                            marginTop={'30%'}
                        >
                            <AccountDetailsContainer>
                                <PhysicianDetails
                                    ref={physicianDetailsRef}
                                    accountDetail={physicianDetail}
                                    handleClose={handleClose}
                                    fromAccounts={true}
                                    isFromAccount={true}
                                    employeeRole={employeeRole}
                                />
                            </AccountDetailsContainer>
                        </ModalDialog>
                    )}
                </>
            )}
        </>
    );
};
export default AssociatedPhysicians;
